<cs-header>
  <cs-header-title>{{ LL.profile.title() }}</cs-header-title>
  <cs-button header-right secondary small [label]="LL.profile.signOut()" (click)="handleSignOut()"></cs-button>
  <cs-icon-button header-right icon="ellipsis-vertical" id="contextMenu"
    (click)="handleOptionsMenu($event)"></cs-icon-button>
</cs-header>

<cs-content>
  <cs-card-list>
    <!-- Blue Info Banner - only for monthly subscribers who can upgrade to yearly -->
    @if (subscriptionCard.canShowSwitchPlanBanner) {
    <cs-info-card type="info" [dismissible]="true" (dismissed)="onBannerDismissed()">
      {{ LL.profile.switchPlanPromo({ current: subscriptionCard.currentPlan?.title, other: subscriptionCard.otherPlan?.title, price: subscriptionCard.otherPlan?.priceText,
      saving: subscriptionCard.otherPlan?.saving }) }}
      <button class="link" (click)="onSwitchPlanClick()">{{ LL.profile.switchToPlan({ plan: subscriptionCard.otherPlan?.title }) }}</button>
    </cs-info-card>
    }

    <!-- Profile Card -->
    <cs-card>
      <cs-card-title>{{ LL.profile.profileSection() }}</cs-card-title>
      <cs-card-content>
        <div class="profile-info">
          <div class="avatar">
            <img [src]="avatarUrl" />
          </div>
          <div class="profile-text">
            <p class="user-name">{{ userName }}</p>
            <p class="user-email">{{ userEmail }}</p>
            @if (impersonationUserAuth !== null) {
            <button type="button" class="user-email impersonation" (click)="onImpersonationIndicatorClicked()">
              <cs-icon name="eye"></cs-icon> {{ impersonationUserAuth.email }}
            </button>
            }
          </div>
        </div>
      </cs-card-content>
    </cs-card>

    <!-- Subscription Card. Every rule about what it shows lives in
         subscription-card-model.ts; the card itself decides nothing and emits
         its buttons back here, where the actions run. -->
    <cs-subscription-card [model]="subscriptionCard"
      (upgradeClick)="gotoPurchase()"
      (resumeClick)="onResumeClick()"
      (manageSubscriptionClick)="onManageSubscriptionClick()"
      (switchPlanClick)="onSwitchPlanClick()"></cs-subscription-card>

    <!-- Temporary-status info card: visible while INTERNAL_UnderReview has granted
         provisional access via SubscriptionStatus.Temporary. Hides automatically when
         the TrialCharge IPN flips the status to Active and roleIsTemporary becomes false.
         Non-dismissible — the user needs the signal for the duration of the Review window. -->
    @if (roleIsTemporary) {
    <cs-info-card type="info" [dismissible]="false">
      {{ LL.subscribe.temporaryInfoCard.message() }}
    </cs-info-card>
    }

    <!-- Support Card -->
    <cs-card>
      <cs-card-title>{{ LL.profile.support() }}</cs-card-title>
      <cs-card-content class="support-content">
        <cs-item-list>
          <cs-note big light [innerHTML]="LL.profile.reportIssueInfo()"></cs-note>

          <cs-item>
            <cs-button secondary small [label]="LL.profile.emailSupport()"
              (click)="onReportProblemButtonClicked()"></cs-button>
          </cs-item>

        </cs-item-list>
      </cs-card-content>
    </cs-card>

    <!-- Cancel subscription. Kept in the page rather than the card component
         because the support card sits between them. When it shows is decided by
         showCancelRow in subscription-card-model.ts. -->
    @if (subscriptionCard.showCancelRow) {
    <cs-card-list-row type="translucent" class="cancel-subscription-card">
      <cs-button tertiary warning [label]="LL.profile.cancelSubscription()" [disabled]="loadingSlowData"
        (click)="onCancelClick()">
      </cs-button>
    </cs-card-list-row>
    }

    <!-- Footer Links -->
    <cs-card-list-row type="translucent" class="profile-footer">
      <div class="profile-footer">
        <cs-button tertiary [label]="LL.profile.termsAndConditions()" (click)="openLink('/tos.html')"></cs-button>
        <cs-button tertiary [label]="LL.profile.privacyPolicy()" (click)="openLink('/privacy.html')"></cs-button>
        <!-- refunds are Paddle-web-only: hide on native, where Apple / Google
             handle payments and Paddle refunds do not apply. -->
        @if (isWeb) {
          <cs-button tertiary [label]="LL.profile.refundPolicy()" (click)="openLink('/refund.html')"></cs-button>
        }
        <cs-button tertiary [label]="LL.profile.healthDisclaimer()"
          (click)="openLink('/health-disclaimer.html')"></cs-button>
      </div>
    </cs-card-list-row>
  </cs-card-list>
</cs-content>